import {CommonModule, CurrencyPipe} from '@angular/common';
import {Component, Input} from '@angular/core';
import {
  ArchivedProtection,
  Duration,
  HUMANIA_EMMA_V2_PROVIDER,
  isWholeLife,
  Protection,
  RiderType,
} from '@emma-labs/shared/typescript';
import {DividerModule} from 'primeng/divider';

interface SelectedProduct {
  coverage: number;
  duration?: Duration;
  price: number;
  riderType?: RiderType;
  riderDuration?: number;
}

type SelectedProtection = Protection | ArchivedProtection;

@Component({
  selector: 'em-selected-product-section',
  templateUrl: './selected-product-section.component.html',
  styleUrls: ['./selected-product-section.component.scss'],
  imports: [CommonModule, DividerModule, CurrencyPipe],
})
export class SelectedProductSectionComponent {
  @Input({required: true}) set protection(protection: SelectedProtection | undefined) {
    this.updateSelectedProducts(protection);
  }

  readonly isWholeLife = isWholeLife;
  readonly riderType = RiderType;
  selectedProducts: SelectedProduct[] = [];

  updateSelectedProducts(protection: SelectedProtection | undefined) {
    this.selectedProducts = [];
    protection?.personInsurances.forEach((pi) => {
      let price: number;
      if (!pi.riders) {
        price = pi.price;
      } else {
        price = pi.price - pi.riders.reduce((acc, curr) => acc + (curr.price as number), 0);
      }

      this.selectedProducts.push({coverage: pi.coverage, duration: pi.duration, price});
    });

    HUMANIA_EMMA_V2_PROVIDER.riderTypes?.forEach((riderType) => {
      const rider = protection?.personInsurances
        .flatMap((personInsurance) => personInsurance.riders)
        .find((rider) => rider?.type === riderType);

      if (rider?.price) {
        this.selectedProducts.push({
          coverage: rider.coverage,
          price: rider.price,
          riderType: riderType,
          riderDuration: rider.duration,
        });
      }
    });
  }

  get totalPrice(): number {
    return this.selectedProducts.reduce((acc, curr) => acc + curr.price, 0);
  }
}
